"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const useHandleInputChange = () => {
    const [localValues, setLocalValues] = (0, react_1.useState)({
        maxStock: 0,
        currStock: 0,
        price: 0,
    });
    const handleInputChange = (e, field) => {
        const newValue = 'value' in e ? (e.value ?? 0) : parseFloat(e.target.value) || 0;
        setLocalValues((prevValues) => ({
            ...prevValues,
            [field]: newValue,
        }));
    };
    return { localValues, handleInputChange, setLocalValues };
};
exports.default = useHandleInputChange;
